import { transform4DimensionalDirectionalLogicalProperty } from './utils/transform_four_dimensional_directional_logical_property.js';
import { transformLogicalBlockProperty } from './utils/transform_logical_block_property.js';
import { transformLogicalInlineProperty } from './utils/transform_logical_inline_property.js';
import { transformLogicalInlinePropertyWithShorthand } from './utils/transform_logical_inline_property_with_shorthand.js';
import { transformLogicalProperty } from './utils/transform_logical_property.js';

var transformFunctionsMap = {
  "block-size": transformLogicalProperty(["height"]),
  "max-block-size": transformLogicalProperty(["max-height"]),
  "min-block-size": transformLogicalProperty(["min-height"]),
  "inline-size": transformLogicalProperty(["width"]),
  "max-inline-size": transformLogicalProperty(["max-width"]),
  "min-inline-size": transformLogicalProperty(["min-width"]),
  "margin-inline": transformLogicalInlinePropertyWithShorthand({
    ltrStartProperty: "margin-left",
    ltrEndProperty: "margin-right"
  }),
  "margin-inline-end": transformLogicalInlineProperty({
    ltrFallbackStyle: "margin-right",
    rtlFallbackStyle: "margin-left"
  }),
  "margin-inline-start": transformLogicalInlineProperty({
    ltrFallbackStyle: "margin-left",
    rtlFallbackStyle: "margin-right"
  }),
  "margin-block": transformLogicalBlockProperty(["margin-top", "margin-bottom"]),
  "margin-block-end": transformLogicalProperty(["margin-bottom"]),
  "margin-block-start": transformLogicalProperty(["margin-top"]),
  inset: transform4DimensionalDirectionalLogicalProperty({
    blockStartProperty: "top",
    blockEndProperty: "bottom",
    inlineStartProperty: "left",
    inlineEndProperty: "right"
  }),
  "inset-inline": transformLogicalInlinePropertyWithShorthand({
    ltrStartProperty: "left",
    ltrEndProperty: "right"
  }),
  "inset-inline-end": transformLogicalInlineProperty({
    ltrFallbackStyle: "right",
    rtlFallbackStyle: "left"
  }),
  "inset-inline-start": transformLogicalInlineProperty({
    ltrFallbackStyle: "left",
    rtlFallbackStyle: "right"
  }),
  "inset-block": transformLogicalBlockProperty(["top", "bottom"]),
  "inset-block-end": transformLogicalProperty(["bottom"]),
  "inset-block-start": transformLogicalProperty(["top"]),
  "padding-inline": transformLogicalInlinePropertyWithShorthand({
    ltrStartProperty: "padding-left",
    ltrEndProperty: "padding-right"
  }),
  "padding-inline-end": transformLogicalInlineProperty({
    ltrFallbackStyle: "padding-right",
    rtlFallbackStyle: "padding-left"
  }),
  "padding-inline-start": transformLogicalInlineProperty({
    ltrFallbackStyle: "padding-left",
    rtlFallbackStyle: "padding-right"
  }),
  "padding-block": transformLogicalBlockProperty(["padding-top", "padding-bottom"]),
  "padding-block-end": transformLogicalProperty(["padding-bottom"]),
  "padding-block-start": transformLogicalProperty(["padding-top"]),
  "border-block": transformLogicalProperty(["border-top", "border-bottom"]),
  "border-block-color": transformLogicalProperty(["border-top-color", "border-bottom-color"]),
  "border-block-style": transformLogicalProperty(["border-top-style", "border-bottom-style"]),
  "border-block-width": transformLogicalProperty(["border-top-width", "border-bottom-width"]),
  "border-block-end": transformLogicalProperty(["border-bottom"]),
  "border-block-end-color": transformLogicalProperty(["border-bottom-color"]),
  "border-block-end-style": transformLogicalProperty(["border-bottom-style"]),
  "border-block-end-width": transformLogicalProperty(["border-bottom-width"]),
  "border-block-start": transformLogicalProperty(["border-top"]),
  "border-block-start-color": transformLogicalProperty(["border-top-color"]),
  "border-block-start-style": transformLogicalProperty(["border-top-style"]),
  "border-block-start-width": transformLogicalProperty(["border-top-width"]),
  "border-inline": transformLogicalProperty(["border-left", "border-right"]),
  "border-inline-color": transformLogicalProperty(["border-left-color", "border-right-color"]),
  "border-inline-style": transformLogicalProperty(["border-left-style", "border-right-style"]),
  "border-inline-width": transformLogicalProperty(["border-left-width", "border-right-width"]),
  "border-inline-end": transformLogicalInlineProperty({
    ltrFallbackStyle: "border-right",
    rtlFallbackStyle: "border-left"
  }),
  "border-inline-end-color": transformLogicalInlineProperty({
    ltrFallbackStyle: "border-right-color",
    rtlFallbackStyle: "border-left-color"
  }),
  "border-inline-end-style": transformLogicalInlineProperty({
    ltrFallbackStyle: "border-right-style",
    rtlFallbackStyle: "border-left-style"
  }),
  "border-inline-end-width": transformLogicalInlineProperty({
    ltrFallbackStyle: "border-right-width",
    rtlFallbackStyle: "border-left-width"
  }),
  "border-inline-start": transformLogicalInlineProperty({
    ltrFallbackStyle: "border-left",
    rtlFallbackStyle: "border-right"
  }),
  "border-inline-start-color": transformLogicalInlineProperty({
    ltrFallbackStyle: "border-left-color",
    rtlFallbackStyle: "border-right-color"
  }),
  "border-inline-start-style": transformLogicalInlineProperty({
    ltrFallbackStyle: "border-left-style",
    rtlFallbackStyle: "border-right-style"
  }),
  "border-inline-start-width": transformLogicalInlineProperty({
    ltrFallbackStyle: "border-left-width",
    rtlFallbackStyle: "border-right-width"
  }),
  "border-end-end-radius": transformLogicalInlineProperty({
    ltrFallbackStyle: "border-bottom-right-radius",
    rtlFallbackStyle: "border-bottom-left-radius"
  }),
  "border-end-start-radius": transformLogicalInlineProperty({
    ltrFallbackStyle: "border-bottom-left-radius",
    rtlFallbackStyle: "border-bottom-right-radius"
  }),
  "border-start-end-radius": transformLogicalInlineProperty({
    ltrFallbackStyle: "border-top-right-radius",
    rtlFallbackStyle: "border-top-left-radius"
  }),
  "border-start-start-radius": transformLogicalInlineProperty({
    ltrFallbackStyle: "border-top-left-radius",
    rtlFallbackStyle: "border-top-right-radius"
  })
};

export { transformFunctionsMap };
